import ClassNames from "classnames";
import { FunctionComponent, RefCallback } from "react";
import i18n from "../i18n/index.js";
import styles from "../stylesheets/components/full-menu-button.module.css";
import { Language } from "../types/index.js";
import { getTranslations } from "../utils/utils.js";
import Icon from "./Icon.js";

interface Props {
  languageId: Language;
  isOpen: boolean;
  className?: string;
  onClick: () => void;
  innerRef?: RefCallback<HTMLElement>;
}

const FullMenuButton: FunctionComponent<Props> = ({
  languageId,
  isOpen,
  className,
  onClick,
  innerRef,
}) => {
  const { menu } = getTranslations(languageId, i18n);

  return (
    <button
      ref={innerRef}
      onClick={onClick}
      type="button"
      className={ClassNames("Btn--bare", styles.FullMenuButton, className)}
    >
      <span className={styles.FullMenuButton__Inner}>
        <Icon
          className={styles.FullMenuButton__Icon}
          glyph={isOpen ? "close" : "view-headline"}
        />
      </span>
      <span className={styles.FullMenuButton__Text}>{menu.menu}</span>
    </button>
  );
};

export default FullMenuButton;
